export { default, ScreenRecorder } from "./ScreenRecorder";
